/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import {Component} from 'vue-property-decorator';
import {LservVue} from '@/shell/LservVue';

/**
 * Common base for the content part of an expanded commercial or non-commercial license record.
 */
@Component
export default class ExpandedLicenseRecordContent extends LservVue {

  /**
   * @override
   */
  protected getI18nBase(): string {
    return `views.common.licenses.ExpandedLicenseRecordContent`;
  }
}
